enum UserVehicleOwnership {
  OWNER = "OWNER",
  BUSINESS = "BUSINESS",
}

export default UserVehicleOwnership;
